
import React, { useEffect, useState } from "react";
import "./export_part.css";
import { Button, Form, Input, Select, notification } from "antd";
import axios from "axios";
import { PiExportLight } from "react-icons/pi";

const ExportPart: React.FC = () => {
    const [warehouses, setWarehouses] = useState<{ warehouse_code: string; warehouse_name: string }[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm();
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    useEffect(() => {
        const fetchWarehouses = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/export-part/warehouses`);
                setWarehouses(response.data);
            } catch (error) {
                console.error("Failed to fetch warehouses:", error);
            }
        };
        fetchWarehouses();
    }, []);

    const handleExport = async () => {
        try {
            const values = await form.validateFields();
            const warehouse = values.warehouse;
            if (!warehouse) return;
            setLoading(true);
            const key = "export-progress";
            let progress = 0;

            notification.open({
                key,
                message: "Exporting Data",
                description: "Processing... 0%",
                duration: 0,
            });

            const interval = setInterval(() => {
                progress += 10;
                if (progress <= 100) {
                    notification.open({
                        key,
                        message: "Exporting Data",
                        description: `Processing... ${progress}%`,
                        duration: 0,
                    });
                }
                if (progress >= 100) {
                    clearInterval(interval);
                }
            }, 300);
            await new Promise((resolve) => setTimeout(resolve, 3000));
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/export-part/export`, {
                params: { warehouse },
                responseType: "blob",
            });
            const d = new Date();
            const dd = String(d.getDate()).padStart(2, "0");
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const yy = String(d.getFullYear()).slice(-2);
            const dateStr = `${dd}${mm}${yy}`;

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Export_Part_${warehouse}_${dateStr}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);

            notification.success({
                key,
                message: "Export Success",
                description: "File downloaded successfully.",
                duration: 3,
            });
        } catch (error) {
            console.error("Export failed:", error);
            notification.error({
                message: "Export Failed",
                description: "An error occurred during export.",
                duration: 3,
            });
        } finally {
            setLoading(false);
        }
    };

    return (

        <div id="i16u" style={transformStyle}>
            <div className="gjs-grid-row" id="ivj4k">
                <div className="gjs-grid-column" id="i4zkj">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                showSearch
                                placeholder="Pilih Warehouse"
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                options={warehouses.map(w => ({ label: w.warehouse_name, value: w.warehouse_code }))}
                            />
                        </Form.Item>
                    </Form>
                    <Button className="gr-button" onClick={handleExport} disabled={loading}>
                        <PiExportLight style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Export
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ExportPart;
